
import { supabase } from "@/integrations/supabase/client";

/**
 * Validates a school with Infradigital before subscription creation
 */
export const validateSchoolRegistration = async (schoolId: string) => {
  console.log('Validating school registration with Infradigital:', schoolId);
  const testData = {
    data: {
      "test_mode": true,
      "biller_code": "60000",
      "bill_key": schoolId
    }
  };
  
  try {
    const { data: validationResponse, error: validationError } = await supabase.functions.invoke('infradigital-check', {
      body: testData
    });
    
    if (validationError) {
      console.error('School validation failed (validation error):', validationError);
      throw new Error(`SCHOOL_NOT_REGISTERED:${schoolId}`);
    }
    
    if (!validationResponse || validationResponse.status === "failed") {
      console.error('School validation failed (validation response):', validationResponse);
      // Check if there's a specific message in the response
      const errorMessage = validationResponse?.message || `SCHOOL_NOT_REGISTERED:${schoolId}`;
      throw new Error(errorMessage);
    }
    
    console.log('School validation successful:', validationResponse);
    return true;
  } catch (validationError) {
    console.error('School validation error:', validationError);
    
    // Improved error handling for better UI feedback
    if (validationError.message) {
      if (validationError.message.includes('SCHOOL_NOT_REGISTERED') ||
          validationError.message === 'SCHOOL_NOT_REGISTERED') {
        throw new Error(`SCHOOL_NOT_REGISTERED:${schoolId}`);
      }
    }
    
    throw new Error(`SCHOOL_NOT_REGISTERED:${schoolId}`);
  }
};

/**
 * Checks for past due subscriptions that can be reactivated
 */
export const checkForPastDueSubscription = async (clientId: string, productId: string | undefined) => {
  if (!productId) return null;
  
  const { data: pastDueSubscription } = await supabase
    .from('subscriptions')
    .select(`
      id,
      plan_id,
      plans!inner(feature_id)
    `)
    .eq('client_id', clientId)
    .eq('status', 'past_due')
    .eq('plans.feature_id', productId)
    .maybeSingle();
  
  return pastDueSubscription;
};
